(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limited-time-sale-collections"] && !Shopify.designMode) return;
  try {
    
      function sortTomoSaleCollections(section) {
        const grid =
    section.querySelector('.limited-time-sale-collections__grid');
        if (!grid) return;
        const today = new Date().toISOString().slice(0, 10);
        const dailyScore = (value) => {
          const input = `${today}:${value}`;
          let hash = 0;
          for (let i = 0; i < input.length; i += 1) {
            hash = (hash << 5) - hash + input.charCodeAt(i);
            hash |= 0;
          }
          return Math.abs(hash);
        };
        Array.from(grid.querySelectorAll('[data-tomo-sale-card]'))
          .sort((a, b) => {
            const order = section.dataset.tomoSaleSortOrder || 'ending_latest';
            if (order === 'random') return Math.random() - 0.5;
            if (order === 'daily_random') {
              const ak = a.dataset.saleCardKey || a.dataset.saleEndsAtTimestamp || '';
              const bk = b.dataset.saleCardKey || b.dataset.saleEndsAtTimestamp || '';
              return dailyScore(ak) - dailyScore(bk);
            }
            const ea = Number(a.dataset.saleEndsAtTimestamp) || 0;
            const eb = Number(b.dataset.saleEndsAtTimestamp) || 0;
            return order === 'ending_soon' ? ea - eb : eb - ea;
          })
          .forEach((card) => grid.appendChild(card));
      }

      function updateCarouselControls(section) {
        const c = section.querySelector('[data-tomo-sale-carousel]');
        const controls =
    section.querySelector('.limited-time-sale-collections__controls');
        const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
        const next = section.querySelector('[data-tomo-sale-carousel-next]');
        if (!c || !controls || !prev || !next) return;
        const maxScroll = c.scrollWidth - c.clientWidth;
        controls.hidden = maxScroll <= 2;
        prev.disabled = c.scrollLeft <= 2;
        next.disabled = c.scrollLeft >= maxScroll - 2;
      }

      function tickCountdown(cd) {
        if (typeof cd.tick !== 'function') return false;
        const r = cd.tick();
        return r !== false && cd.isConnected && !cd.hidden;
      }

      function restartCountdowns(section) {
        window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals ||
    new WeakMap();
        section.querySelectorAll('tomo-sale-countdown').forEach((cd) => {
          if (window.tomoSaleCountdownIntervals.has(cd)) return;
          if (!tickCountdown(cd)) return;
          const i = window.setInterval(() => {
            if (tickCountdown(cd)) return;
            window.clearInterval(i);
            window.tomoSaleCountdownIntervals.delete(cd);
          }, 1000);
          window.tomoSaleCountdownIntervals.set(cd, i);
        });
      }

      function scrollCarousel(section, dir) {
        const c = section.querySelector('[data-tomo-sale-carousel]');
        if (!c) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        c.scrollBy({ left: c.clientWidth * dir * 0.9, behavior: reduced ? 'auto' :
     'smooth' });
      }

      function initSection(section) {
        sortTomoSaleCollections(section);
        restartCountdowns(section);
        updateCarouselControls(section);
        if (section.dataset.tomoSaleCarouselInitialized === 'true') return;
        section.dataset.tomoSaleCarouselInitialized = 'true';
        const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
        const next = section.querySelector('[data-tomo-sale-carousel-next]');
        const c = section.querySelector('[data-tomo-sale-carousel]');
        prev?.addEventListener('click', () => scrollCarousel(section, -1));
        next?.addEventListener('click', () => scrollCarousel(section, 1));
        c?.addEventListener('scroll', () => updateCarouselControls(section), {
    passive: true });
        window.addEventListener('resize', () => updateCarouselControls(section));
      }

      function initAll() {

    document.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
      }

      initAll();
      document.addEventListener('DOMContentLoaded', initAll);
      document.addEventListener('shopify:section:load', (e) => {

    e.target.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltd-sale-coll"] && !Shopify.designMode) return;
  try {
    
  function sortTomoSaleCollections(section) {
    const grid = section.querySelector('.limited-time-sale-collections__grid');
    if (!grid) return;
    const today = new Date().toISOString().slice(0, 10);
    const dailyScore = (value) => {
      const input = `${today}:${value}`;
      let hash = 0;
      for (let i = 0; i < input.length; i += 1) {
        hash = (hash << 5) - hash + input.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    };
    Array.from(grid.querySelectorAll('[data-tomo-sale-sort-item]'))
      .sort((a, b) => {
        const order = section.dataset.tomoSaleSortOrder || 'oldest_first';
        if (order === 'random') return Math.random() - 0.5;
        if (order === 'daily_random') {
          const ak = a.dataset.saleCardKey || a.dataset.saleEndsAtTimestamp || '';
          const bk = b.dataset.saleCardKey || b.dataset.saleEndsAtTimestamp || '';
          return dailyScore(ak) - dailyScore(bk);
        }
        const sa = Number(a.dataset.saleStartsAtTimestamp) || 0;
        const sb = Number(b.dataset.saleStartsAtTimestamp) || 0;
        const ea = Number(a.dataset.saleEndsAtTimestamp) || 0;
        const eb = Number(b.dataset.saleEndsAtTimestamp) || 0;
        if (order === 'newest_first') return sb - sa;
        if (order === 'ending_soon') return ea - eb;
        if (order === 'ending_latest') return eb - ea;
        return sa - sb;
      })
      .forEach((card) => grid.appendChild(card));
  }

  function updateCarouselControls(section) {
    const c = section.querySelector('[data-tomo-sale-carousel]');
    const controls = section.querySelector('.limited-time-sale-collections__controls');
    const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
    const next = section.querySelector('[data-tomo-sale-carousel-next]');
    if (!c || !controls || !prev || !next) return;
    const maxScroll = c.scrollWidth - c.clientWidth;
    controls.hidden = maxScroll <= 2;
    prev.disabled = c.scrollLeft <= 2;
    next.disabled = c.scrollLeft >= maxScroll - 2;
  }

  function tickCountdown(cd) {
    if (typeof cd.tick !== 'function') return false;
    const r = cd.tick();
    return r !== false && cd.isConnected && !cd.hidden;
  }

  function restartCountdowns(section) {
    window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals || new WeakMap();
    section.querySelectorAll('tomo-sale-countdown').forEach((cd) => {
      if (window.tomoSaleCountdownIntervals.has(cd)) return;
      if (!tickCountdown(cd)) return;
      const i = window.setInterval(() => {
        if (tickCountdown(cd)) return;
        window.clearInterval(i);
        window.tomoSaleCountdownIntervals.delete(cd);
      }, 1000);
      window.tomoSaleCountdownIntervals.set(cd, i);
    });
  }

  function scrollCarousel(section, dir) {
    const c = section.querySelector('[data-tomo-sale-carousel]');
    if (!c) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    c.scrollBy({ left: c.clientWidth * dir * 0.9, behavior: reduced ? 'auto' : 'smooth' });
  }

  function initSection(section) {
    sortTomoSaleCollections(section);
    restartCountdowns(section);
    updateCarouselControls(section);
    if (section.dataset.tomoSaleCarouselInitialized === 'true') return;
    section.dataset.tomoSaleCarouselInitialized = 'true';
    const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
    const next = section.querySelector('[data-tomo-sale-carousel-next]');
    const c = section.querySelector('[data-tomo-sale-carousel]');
    prev?.addEventListener('click', () => scrollCarousel(section, -1));
    next?.addEventListener('click', () => scrollCarousel(section, 1));
    c?.addEventListener('scroll', () => updateCarouselControls(section), { passive: true });
    window.addEventListener('resize', () => updateCarouselControls(section));
  }

  function initAll() {
    document.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-flash-v3"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-shop-all-sales"] && !Shopify.designMode) return;
  try {
    
    function sortTomoSaleCollections(section) {
      const grid =
  section.querySelector('.limited-time-sale-collections__grid');
      if (!grid) return;
      const today = new Date().toISOString().slice(0, 10);
      const dailyScore = (value) => {
        const input = `${today}:${value}`;
        let hash = 0;
        for (let i = 0; i < input.length; i += 1) {
          hash = (hash << 5) - hash + input.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash);
      };
      Array.from(grid.querySelectorAll('[data-tomo-sale-card]'))
        .sort((a, b) => {
          const order = section.dataset.tomoSaleSortOrder || 'ending_latest';
          if (order === 'random') return Math.random() - 0.5;
          if (order === 'daily_random') {
            const ak = a.dataset.saleCardKey || a.dataset.saleEndsAtTimestamp || '';
            const bk = b.dataset.saleCardKey || b.dataset.saleEndsAtTimestamp || '';
            return dailyScore(ak) - dailyScore(bk);
          }
          const ea = Number(a.dataset.saleEndsAtTimestamp) || 0;
          const eb = Number(b.dataset.saleEndsAtTimestamp) || 0;
          return order === 'ending_soon' ? ea - eb : eb - ea;
        })
        .forEach((card) => grid.appendChild(card));
    }

    function updateCarouselControls(section) {
      const c = section.querySelector('[data-tomo-sale-carousel]');
      const controls =
  section.querySelector('.limited-time-sale-collections__controls');
      const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
      const next = section.querySelector('[data-tomo-sale-carousel-next]');
      if (!c || !controls || !prev || !next) return;
      const maxScroll = c.scrollWidth - c.clientWidth;
      controls.hidden = maxScroll <= 2;
      prev.disabled = c.scrollLeft <= 2;
      next.disabled = c.scrollLeft >= maxScroll - 2;
    }

    function tickCountdown(cd) {
      if (typeof cd.tick !== 'function') return false;
      const r = cd.tick();
      return r !== false && cd.isConnected && !cd.hidden;
    }

    function restartCountdowns(section) {
      window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals ||
  new WeakMap();
      section.querySelectorAll('tomo-sale-countdown').forEach((cd) => {
        if (window.tomoSaleCountdownIntervals.has(cd)) return;
        if (!tickCountdown(cd)) return;
        const i = window.setInterval(() => {
          if (tickCountdown(cd)) return;
          window.clearInterval(i);
          window.tomoSaleCountdownIntervals.delete(cd);
        }, 1000);
        window.tomoSaleCountdownIntervals.set(cd, i);
      });
    }

    function initLoadMore(section) {
      const grid = section.querySelector('.limited-time-sale-collections__grid');
      const wrap = section.querySelector('[data-tomo-sale-loadmore-wrap]');
      const button = section.querySelector('[data-tomo-sale-loadmore]');
      if (!grid || !wrap || !button) return;

      const step = Number(section.dataset.tomoSaleInitialVisible) || 50;
      let visible = step;

      function applyVisibility() {
        const cards = Array.from(grid.querySelectorAll('[data-tomo-sale-card]'));
        cards.forEach((card, index) => {
          card.hidden = index >= visible;
        });
        wrap.hidden = visible >= cards.length;
      }

      if (section.dataset.tomoSaleLoadMoreInitialized !== 'true') {
        section.dataset.tomoSaleLoadMoreInitialized = 'true';
        button.addEventListener('click', () => {
          visible += step;
          applyVisibility();
          restartCountdowns(section);
        });
      }

      applyVisibility();
    }

    function scrollCarousel(section, dir) {
      const c = section.querySelector('[data-tomo-sale-carousel]');
      if (!c) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      c.scrollBy({ left: c.clientWidth * dir * 0.9, behavior: reduced ? 'auto' :
   'smooth' });
    }

    function initSection(section) {
      sortTomoSaleCollections(section);
      initLoadMore(section);
      restartCountdowns(section);
      updateCarouselControls(section);
      if (section.dataset.tomoSaleCarouselInitialized === 'true') return;
      section.dataset.tomoSaleCarouselInitialized = 'true';
      const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
      const next = section.querySelector('[data-tomo-sale-carousel-next]');
      const c = section.querySelector('[data-tomo-sale-carousel]');
      prev?.addEventListener('click', () => scrollCarousel(section, -1));
      next?.addEventListener('click', () => scrollCarousel(section, 1));
      c?.addEventListener('scroll', () => updateCarouselControls(section), {
  passive: true });
      window.addEventListener('resize', () => updateCarouselControls(section));
    }

    function initAll() {
  
  document.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', (e) => {
  
  e.target.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-homepage-live-sales"] && !Shopify.designMode) return;
  try {
    
  function sortTomoLiveSalesEndingSoon() {
    document.querySelectorAll('[data-tomo-live-sales-grid]').forEach((grid) => {
      Array.from(grid.querySelectorAll('.tomo-live-sales__card'))
        .sort((cardA, cardB) => {
          const endsAtA = Number(cardA.dataset.saleEndsAtTimestamp) || 0;
          const endsAtB = Number(cardB.dataset.saleEndsAtTimestamp) || 0;

          return endsAtA - endsAtB;
        })
        .forEach((card) => grid.appendChild(card));
    });
  }

  sortTomoLiveSalesEndingSoon();
  document.addEventListener('DOMContentLoaded', sortTomoLiveSalesEndingSoon);
  document.addEventListener('shopify:section:load', sortTomoLiveSalesEndingSoon);

  } catch(e) { console.error(e); }
})();
})();
